import Chip from "@Components/Decor/Chip";
import { NextArrowIcon, StarIcon as Star } from "@Icons/MainIcons";
import { FC, RefObject } from "react";
import { useTranslation } from "react-i18next";
import LandingHeroDecor from "./components/LandingHeroDecor";


const LandingHero: FC<{ contentRef: RefObject<HTMLElement> }> = ({ contentRef }) => {
  const { t } = useTranslation();

  return (
    <section className="relative flex h-full w-full justify-start overflow-hidden px-4 md:py-10 py-5 max-lg:pb-64 font-inter">
      <LandingHeroDecor/>

      <div className="relative z-10 flex max-w-[80%] py-10 flex-col items-start gap-7 text-start max-lg:max-w-full lg:w-full lg:ps-16">
        <Chip title={t("Landing.hero.badge")} icon={<div className="bg-font-active aspect-square w-2 rounded-full" />} />
        <h1 className="-mt-1 text-3xl flex flex-wrap font-bold md:text-6xl lg:flex lg:flex-col lg:items-start">
          <span>{t("Landing.hero.titleLine1")}</span>
          <span className="text-font-active">{t("Landing.hero.titleLine2")}</span>
        </h1>
        <p className="text-font-subtle text-sm">{t("Landing.hero.subtitle")}</p>
        <button
          type="button"
          onClick={() => contentRef.current?.scrollIntoView({ behavior: "smooth", block: "start" })}
          className="bg-background-primary shadow-action flex cursor-pointer items-center gap-2 rounded-full px-6 py-2 text-sm pe-2! font-semibold text-white"
        >
          {t("Landing.hero.cta")}
          <span className="bg-background-default text-font-active rounded-full p-2">
            <NextArrowIcon className="h-3 w-3" />
          </span>
        </button>

        <div className="text-font-subtle -mt-3 flex items-center gap-1 text-xs italic">
          <Star className="text-font-active h-3 w-3" />
          {t("Landing.hero.footnote")}
        </div>
      </div>
    </section>
  );
};

export default LandingHero;
